module.exports = __webpack_public_path__ + "img/expense_account.e293a9aa.png";